export const toPrice = (val)=> Number(val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$& ").replace(" ", " ").replace(".00", " Kč");